import { CircleHelp } from "lucide-react";
import { Dialog, DialogContent } from "./dialog";
import "./help-video-dialog.css";

function getVimeoEmbedUrl(value) {
  const source = String(value || "").trim();
  if (!source) return "";

  try {
    const url = /^\d+$/.test(source) ? new URL(`https://vimeo.com/${source}`) : new URL(source);
    const host = url.hostname.toLowerCase();
    if (host !== "vimeo.com" && host !== "www.vimeo.com" && host !== "player.vimeo.com") return "";

    const videoId = url.pathname.split("/").filter((part) => /^\d+$/.test(part)).pop();
    if (!videoId) return "";

    const embedUrl = new URL(`https://player.vimeo.com/video/${videoId}`);
    url.searchParams.forEach((parameterValue, parameterName) => {
      embedUrl.searchParams.set(parameterName, parameterValue);
    });
    if (!embedUrl.searchParams.has("dnt")) embedUrl.searchParams.set("dnt", "1");
    return embedUrl.toString();
  } catch {
    return "";
  }
}

function HelpVideoDialog({ articleUrl, description, onClose, title, videoUrl }) {
  const embedUrl = getVimeoEmbedUrl(videoUrl);

  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="help-video-dialog">

        <div className="help-video-dialog-frame">
          {embedUrl ? (
            <iframe
              allow="autoplay; fullscreen; picture-in-picture"
              allowFullScreen
              className="help-video-dialog-player"
              referrerPolicy="strict-origin-when-cross-origin"
              src={embedUrl}
              title={`${title} video`}
            />
          ) : (
            <div className="help-video-dialog-unavailable">
              <CircleHelp aria-hidden="true" size={24} />
              <strong>Video guide unavailable</strong>
              <span>Use the help article for the written setup steps.</span>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export { HelpVideoDialog, getVimeoEmbedUrl };
